// Service
import WalkerSitterService from '@/app/services/main/walker-sitter/walker-sitter-service';

// Constant
import { STATUS_CODES } from '@/app/constants/status-constants';

// Mixins
import { userMixins } from '@/app/mixins/modules/user-mixins';

export const walkerSitterMixins = {
	mixins: [ userMixins ],
	methods: {
		savedToFavorites(list) {
            const queryParams = { walkerSitterId: list.id, petId: this.getActivePet.id }
			
            WalkerSitterService.saveToFavorite(queryParams)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                        this.callBackSaveFavorite(list);
                    } else {
                        this.showAPIErrorToast('', res);
                    }
                });
        }
	}
}